import React, { useEffect, useState } from 'react';
import { Button } from './ui';
import { Clock, Salad } from 'lucide-react';
const CHECKOUT_URL = 'https://verduras-invisibles.impultienda.ar/checkout';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 52
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-12 px-4 bg-slate-950 relative" data-id="element-148" data-mp="glqwx9sr37px">
      <div className="absolute inset-0 bg-brand-900/10 pointer-events-none" data-id="element-149" data-mp="lkbsgvx25381" />

      <div className="payment-block max-w-5xl mx-auto relative z-10" id="bloque-pago" data-id="element-150" data-mp="qjes20u9qh8m">
        <div className="text-center mb-5" data-id="element-151" data-mp="ujysbda520yz">
          <div className="inline-flex items-center gap-2.5 bg-red-500/15 text-red-400 border border-red-500/40 px-5 py-2.5 rounded-full font-bold mb-3 text-sm sm:text-base shadow-[0_0_20px_rgba(239,68,68,0.25)]" data-id="element-152" data-mp="ul02zgn8slg6">
            <Clock className="w-5 h-5 shrink-0 animate-pulse" data-id="element-153" data-mp="1f4n2yhxy2v9g" />
            <span data-id="element-154" data-mp="1a3z2l5ntt22k">PRECIO DE LANZAMIENTO — CIERRA EN:</span>
            <span className="tabular-nums text-white text-base sm:text-lg font-black tracking-wide" data-id="element-155" data-mp="154cpcw7zzltr">
              {String(timeLeft.h).padStart(2, '0')}:{String(timeLeft.m).padStart(2, '0')}:{String(timeLeft.s).padStart(2, '0')}
            </span>
          </div>
          <p className="text-brand-400 font-medium text-sm flex items-center justify-center gap-2" data-id="element-156" data-mp="1xuv1snum2zju">⚠️ Después sube $5.000 ARS. No vuelve.</p>
          <div className="w-full max-w-md mx-auto mt-3 bg-slate-800 rounded-full h-1.5 overflow-hidden" data-id="element-157" data-mp="1o3i8rsx2u3c8"><div className="bg-brand-500 h-full w-[72%]" data-id="element-158" data-mp="2li2wkbueyq7m" /></div>
          <p className="text-[11px] text-slate-500 mt-1.5" data-id="element-159" data-mp="2lkflxa2i42up">72% de los cupos al precio de lanzamiento ya tomados</p>
        </div>

        <h2 className="text-2xl md:text-4xl font-bold text-center text-white mb-5" data-id="element-160" data-mp="euc9qaaswcuj">EMPEZÁ A TRANSFORMAR SUS COMIDAS HOY</h2>

        <div className="flex flex-col gap-3 max-w-2xl mx-auto" role="radiogroup" aria-label="Elegí el Megapack Verduras Invisibles" data-id="element-161" data-mp="jtgiizttc8kc">
          <button type="button" role="radio" aria-checked={true} className="relative w-full text-left rounded-2xl border p-4 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 focus:ring-offset-slate-950 border-brand-500 bg-wine-800/40 shadow-[0_0_20px_rgba(232,121,27,0.25)]" data-id="element-162" data-mp="540sxn60q968">
            <div className="flex items-start gap-3" data-id="element-163" data-mp="3icdnf02y8hsm">
              <span className="mt-0.5 shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors border-brand-400 bg-brand-500" aria-hidden="true" data-id="element-164" data-mp="3n9nk90so3vqh"><span className="w-2 h-2 rounded-full bg-white" data-id="element-165" data-mp="1gk92i8jvakre" /></span>
              <div className="min-w-0 flex-1" data-id="element-166" data-mp="1lh7sqg0eu7kb">
                <h3 className="font-bold text-white text-base flex items-center gap-2 leading-tight" data-id="element-167" data-mp="360l0g9vr9nyr">
                  <span className="shrink-0" data-id="element-168" data-mp="311i7vowypa7o"><Salad className="w-6 h-6 text-brand-400" data-id="element-169" data-mp="3129q7y1jtbg0" /></span>
                  <span className="truncate" data-id="element-170" data-mp="3fqeb98o2pz1y">MEGAPACK VERDURAS INVISIBLES</span>
                </h3>
                <p className="text-brand-400 text-xs font-medium mt-0.5" data-id="element-171" data-mp="3azo69wjk7y7s">6 Tomos + 5 Bonos</p>
                <p className="text-slate-400 text-xs mt-1.5 leading-snug" data-id="element-172" data-mp="3axtjecoq9w12"><span className="text-slate-500 font-medium" data-id="element-173" data-mp="3oprlw4nxoto9">Ideal para: </span>Madres y padres que quieren que sus hijos coman más nutritivo, sin trozos visibles y sin cocinar dos comidas distintas</p>
                <p className="text-[11px] font-medium mt-1.5 text-brand-400" data-id="element-174" data-mp="2ijjnb8b92wg">Precio de lanzamiento</p>
              </div>
              <div className="shrink-0 text-right pl-1" data-id="element-175" data-mp="3to2wwipyta82">
                <p className="text-slate-500 line-through text-xs leading-none mb-1" data-id="element-176" data-mp="24ag08z9c52y3">$49.000</p>
                <p className="text-2xl sm:text-3xl font-black text-white leading-none" data-id="element-177" data-mp="1zcwlzzcn0q65">$19.990</p>
                <p className="text-[10px] text-slate-400 mt-0.5" data-id="element-178" data-mp="qfzdu39u6868">ARS</p>
              </div>
            </div>
          </button>
        </div>

        <div className="max-w-2xl mx-auto mt-5" data-id="element-179" data-mp="vcg5h7g8v4o2">
          <Button className="w-full text-base py-4 shadow-[0_0_20px_rgba(232,121,27,0.45)]" onClick={() => {
          window.location.href = CHECKOUT_URL;
        }} data-id="element-180" data-mp="10cufuw5biqp9">
            🥦 QUIERO EL MEGAPACK COMPLETO
          </Button>
          <p className="text-center text-xs text-slate-500 mt-2" data-id="element-181" data-mp="7phsijrc2euw">Garantía 7 días · Pago seguro · Acceso inmediato</p>
        </div>
      </div>
    </section>;
}